import { Injectable } from '@angular/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class FirebaseCrashlyticsService {

  constructor() { }

  crash = async (msg: string) => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.crash({ message: msg });
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  setCustomKey = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.setCustomKey({
          key: 'page',
          value: 'home',
          type: 'string',
        });
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  setUserId = async (userId: string) => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.setUserId({
          userId: userId,
        });
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  log = async (msg: string) => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.log({
          message: msg,
        });
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  setEnabled = async (status: boolean) => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.setEnabled({
          enabled: status,
        });
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  isEnabled = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        const enabled = await FirebaseCrashlytics.isEnabled();
        return enabled;
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
        return false;
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
      return false;
    }
  };

  didCrashOnPreviousExecution = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        const crashed = await FirebaseCrashlytics.didCrashOnPreviousExecution();
        return crashed;
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
        return false;
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
      return false;
    }
  };

  sendUnsentReports = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.sendUnsentReports();
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  deleteUnsentReports = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.deleteUnsentReports();
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  recordException = async () => {
    if (Capacitor.isNativePlatform()) {
      try {
        await FirebaseCrashlytics.recordException({
          message: 'This is a non-fatal message.',
        });
      } catch (error) {
        console.warn('Firebase Crashlytics not available on this platform:', error);
      }
    } else {
      console.log('Firebase Crashlytics not available on web platform');
    }
  };

  // import * as StackTrace from 'stacktrace-js';
  // const recordExceptionWithStacktrace = async (error: Error) => {
  //   const stacktrace = await StackTrace.fromError(error);
  //   await FirebaseCrashlytics.recordException({
  //     message: 'This is a non-fatal message.',
  //     stacktrace,
  //   });
  // };

}
